<template>
  <div class="vip-entrance"
       @click="handleClick"
  >
    马上学习
  </div>
</template>

<script>
  import { isAppWebView, isIosWebView, handleRedirectAPPPage } from '@/utils';

  export default {
    name: 'VipEntrance',
    methods: {
      handleClick() {
        if (isAppWebView()) {
          if (isIosWebView()) {
            handleRedirectAPPPage('youthmba://vip/index');
          } else {
            handleRedirectAPPPage('youthmba://audio/index');
          }
          return;
        }
        this.$router.push({
          name: 'AudioList',
          query: { vipId: 1 },
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-entrance {
    flex: 1;
    align-self: stretch;
    line-height: @vip-bar-height;
    text-align: center;
    color: @vip-bar-content-color;
    font-size: @font-size-medium;
    background: @gradient-black;
    border-radius: 50px;
  }
</style>
